import React, { useContext } from 'react';
import { PRODUCTS } from '../../product';
import { ShopContext } from '../../context/shop-context';
import CartItem from './cart-item';
import "./cart.css";
import { useNavigate } from "react-router-dom";

function Cart() {
const { cartItems, getTotalCartAmount, checkout } = useContext(ShopContext);
const totalAmount = getTotalCartAmount();

const navigate = useNavigate();

return (
<div className='cart'>
  <div className='cartItems'>
  {PRODUCTS.map((product) => {
  const quantity = cartItems[product.id];
  if (quantity > 0) {
    return <CartItem key={product.id} data={product} quantity={quantity} />;
  }
  return null;
})}
  </div>
  <div className="checkout">
    {totalAmount > 0 ? (
    <>
      <p> Subtotal: ${totalAmount} </p>
      <button onClick={()=> navigate("/")}> Continue Shopping </button>
    </>
    ) : (
    <div className='emptyCart'>
      <a onClick={()=> navigate("/")} style={{ cursor: 'pointer' }}>
        <img src='https://iticsystem.com/img/empty-cart.png' alt="Empty Cart"
          style={{ maxWidth: '80%', height: 'auto' }} />
           <h1>Your cart is empty.</h1>
      <h2>Add products to shopping cart and you'll see it next time you visit.</h2>
      </a>
    </div>
    )}
  </div>
</div>
);
}

export default Cart;